export const environment = {
  production: false,
  debug: true,
  APP_ROLE: 'promotor',
  URL_RIBERA_WEB: 'https://dev.cieneguillariberadelrio.com',
  URL_RIBERA_PROMOTERS: 'https://dev.promotores.cieneguillariberadelrio.com',
  INCLUB_RIBERA_API: 'https://api-dev.cieneguillariberadelrio.com',
  WALLET_MICROSERVICE_API: 'https://walletapi-dev.cieneguillariberadelrio.com',
  CMS_MICROSERVICE_API: 'https://cmsapi-dev.cieneguillariberadelrio.com',
  BOOKING_MICROSERVICE_API:
    'https://bookingapi-dev.cieneguillariberadelrio.com',
  NIUBIZ_BUTTON_API:
    'https://static-content-qas.vnforapps.com/v2/js/checkout.js?qa=true',
  MERCHANT_ID: 456879852,
  URL_BACKOFFICE_INCLUB: 'https://www.inclub.world/backoffice',
  PROMOTIONS_RIBERA_API:
    'https://promotionsapi-dev.cieneguillariberadelrio.com',
  ACCOUNT_MICROSERVICE_API:
    'https://accountapi-dev.cieneguillariberadelrio.com',
  SECURITY_MICROSERVICE_API:
    'https://securityapi-dev.cieneguillariberadelrio.com',
  PAYMENT_MICROSERVICE_API:
    'https://paymentapi-dev.cieneguillariberadelrio.com',
  COMMISION_MICROSERVICE_API:
    'https://commisionapi-dev.cieneguillariberadelrio.com',
  PROMOTERS_MICROSERVICE_API:
    'https://promotersapi-dev.cieneguillariberadelrio.com',
  CONCILIATION_MICROSERVICE_API:
    'https://conciliationapi-dev.cieneguillariberadelrio.com',
  features: {
    aiVoucherCheckout: false,
    partialPayments: true,
    newPaymentManager: true,
    izipayEnabled: true,
    niubizEnabled: false,
  },
  // GTM Configuration
  gtm: {
    id: '',
  },
};
